import type { UseStorageOptions } from "@vueuse/core";

import isStorageAvailable from "~/utils/isStorageAvailable";

export type StorageType = "localStorage" | "sessionStorage";

type Params<T> = {
  type: StorageType;
  key: string;
  defaultValue: T;
  options?: UseStorageOptions<T>;
};

export default function useStorageSafely<T>({
  type,
  key,
  defaultValue,
  options,
}: Params<T>) {
  if (type === "localStorage" && isStorageAvailable(type))
    return useLocalStorage<T>(key, defaultValue, options);

  if (type === "sessionStorage" && isStorageAvailable(type))
    return useSessionStorage<T>(key, defaultValue, options);

  return ref<T>(defaultValue);
}
